export default __webpack_public_path__ + "static/media/Contact.35b8d7c0.png";